import { defineRouting } from "next-intl/routing";

// 支持的语言与默认语言。localePrefix: 'always' 保证 `/` 永远重定向到 `/zh` 或 `/en`，
// 不存在无前缀页面（与设计要求 §2 一致：URL 前缀 + Accept-Language 自动检测）。
export const routing = defineRouting({
  locales: ["zh", "en"],
  defaultLocale: "zh",
  localePrefix: "always",
});

export type AppLocale = (typeof routing.locales)[number];
